/* ================  APIs URL ========================*/

export const IMAGE_CDN = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";
export const API_URL = "https://www.swiggy.com/dapi/restaurants/list/v5?lat=28.65420&lng=77.23730&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING";
export const MENU_API = "https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=12.9351929&lng=77.62448069999999&restaurantId=";
export const UPDATE_API = "https://www.swiggy.com/dapi/restaurants/list/update"

/* ================ CONSTANTS ========================*/

export const CONNECTION_STATUS = {
    ONLINE : 'online',
    OFFLINE : 'offline'
}